"use client";

import { useEffect } from "react";

/**
 * Fires a one-shot beacon to /api/auth/track on mount, capturing
 * anonymous /login page views. This lets admins see who's checking
 * out the platform even if they never click Continue with Google.
 */
export function PageViewTracker() {
  useEffect(() => {
    fetch("/api/auth/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ outcome: "page_view" }),
      keepalive: true,
    }).catch(() => {});
  }, []);

  return null;
}
